import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router  } from '@angular/router';
import {PageEvent} from '@angular/material/paginator';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';
import { MiscService } from '../../_service/misc.service';
import { LeadsService } from 'src/app/_service/leads.service';
declare var $: any;
@Component({
  selector: 'app-add-update-treatment',
  templateUrl: './add-update-treatment.component.html',
  styleUrls: ['./add-update-treatment.component.css']
})
export class AddUpdateTreatmentComponent implements OnInit {
  treatmentForm: FormGroup;submitted = false;loading:boolean=false;circles=[];passwordhide:boolean = true;TreatmentId: any = '';circles_copy=[];treatCategory=[];myrole:string;cities=[];cities_copy=[];

  constructor(private router:Router,private sharedapi:SharedService,private formBuilder: FormBuilder,private activatedRoute: ActivatedRoute,public miscapi:MiscService,private leadapi:LeadsService,)
  {

      this.treatmentForm = this.formBuilder.group({
          'catergory_id' : [null, Validators.required],
          'name' : [null, Validators.required],
          'status' : [null, Validators.required],
          'description' : [null, Validators.required],
          'image':[null],
          'available_cities':[null],
      });

      this.activatedRoute.params.subscribe(params => {
          if (params['treatment_id']) {
              this.TreatmentId = params['treatment_id'];
              this.patchTreatmentData();
          }

      });

  }
  async getTreatmentCategory()
  {
      await this.miscapi.getTreat_Category().subscribe((data:any) => {
          if(data.status)
          {
            this.treatCategory = data.data;
          }else{
              this.treatCategory = [];
              this.sharedapi.presentToast(data.msg);
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  get f() { return this.treatmentForm.controls; }

  async patchTreatmentData()
  {
      this.miscapi.getTreatmentData(this.TreatmentId).subscribe((response:any) => {
         console.log(response);
         if(response.status){
             this.treatmentForm.patchValue({
               'catergory_id':response.data.catergory_id,
               'name':response.data.name,
               'status':response.data.status,
               'description': response.data.description,
               'available_cities': response.data.available_cities
              })
         }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  ngOnInit(): void
  {
    this.sharedapi.getRole()
        .subscribe((item:string) => {this.myrole=item;});
    this.myrole = localStorage.getItem('role');
     this.getTreatmentCategory();
     this.getcitiesList();
  }

  sortFunc(a, b) {
    return 1;
  }

  setSearchValue(){
    $("#citySearch").val('');
    $("#citySearch").focus();
    this.cities= this.cities_copy;
  }

  searchOnSelect(searchtText: string, type){
    if (type == 'city') {
        this.cities = this.sharedapi.searchData(searchtText, this.cities_copy, "name");
    }
  }

  async createTreatment(){
      this.submitted = true;
      this.loading = true;
      // stop here if form is invalid
      if (this.treatmentForm.invalid) {
          this.loading = false;
          return;
      }
      //For Update Treatment//
      if(this.TreatmentId){
        this.treatmentForm.value.id= parseInt(this.TreatmentId);

      await this.miscapi.updateTreatment(this.treatmentForm.value)
      .subscribe((data:any) => {
          this.submitted = false;
          this.loading = false;
          if(data.status)
          {
              this.sharedapi.presentToast('Treatment Update Successfully');
              this.router.navigateByUrl('/treatments');
          }
          else
          {
              this.sharedapi.presentToast(data.msg);
          }
        }, error =>
          {
              this.sharedapi.checkError(error);
          });
      }else{
          //For Add Treatment//
          console.log(this.treatmentForm.value);
        await this.miscapi.addTreatment(this.treatmentForm.value)
       .subscribe((data:any) => {
          this.submitted = false;
          this.loading = false;
          if(data.status)
          {
              this.sharedapi.presentToast('Treatment Added Successfully');
              this.router.navigateByUrl('/treatments');
          }
          else
          {
              this.sharedapi.presentToast(data.msg);
          }
        }, error =>
          {
              this.sharedapi.checkError(error);
          });
      }
  }


    selectProfilePic(event)
    {
        const file = (event.target as HTMLInputElement).files[0];
        this.treatmentForm.patchValue({
            image: file
        });
    }

        async getcitiesList()
        {
            await this.leadapi.getcities().subscribe((data:any) => {
                if(data.status)
                {
                    this.cities = data.data;
                    this.cities_copy= this.cities;
                }else{
                    this.cities = [];
                }
            }, error => {
                this.sharedapi.checkError(error);
            });
        }


}
